
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/emprestimo",
      function () {
        return require("private-next-pages/emprestimo/index.js");
      }
    ]);
  